import { DriverIdType, TruckLoadingType } from '../../../../administration/hub';
import {
  CarrierModel,
  ListQueryParam,
  ListRange,
  SearchCriteriaBase,
  TruckSize,
  TruckStatus,
} from '../../../../../../common';

export interface UliItemTruckInformation {
  customsGoods: boolean;
  dangerousGoods: boolean;
  freeTextCarrierName: string;
  lengthOfNextBreak: number;
  loadingTypes: TruckLoadingType[];
  parkingSpaceId: string;
  propertyOfAnother: boolean;
  remainingDrivingTime: number;
  swapBody: boolean;
  trailerPlateId: string;
  trailerPlateIdCountryOfOrigin: string;
  truckId: number;
  truckPlateId: string;
  truckPlateIdCountryOfOrigin: string;
  truckSize: TruckSize;
  truckStatus: TruckStatus;
  inboundSealData: SealCheckTypeData;
  outboundSealData: SealCheckTypeData;
  outboundConfirmationSealData: SealCheckTypeData;
  visitId: string;
}

export interface UliItemDriverInformation {
  firstName: string;
  lastName: string;
  loanerPhoneId: string;
  permitNumber: string;
  permitType: DriverIdType;
  phoneNumber: string;
}

export interface UliItemTruck {
  carrierView: CarrierModel;
  driverInformation: UliItemDriverInformation;
  truckInformationView: UliItemTruckInformation;
}

export interface SealCheckTypeData {
  truckSeal: string;
  truckSealNumber: string;
  truckSealPictureId: string;
  trailerSeal: string;
  trailerSealNumber: string;
  trailerSealPictureId: string;
}

export class UliItemTruckListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: UliItemTruckListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
